import React, { useMemo } from "react";
import { useSelector } from "react-redux";
import { selectProcedure } from "../../../selectors";
import { useUpdateEffect } from "../../../../hooks";


const BorderTransportMode=({saveData,onUpdate,renderForm,title,modeType,isImportShipment})=>{
 
  const procedure = useSelector(selectProcedure);
  const dataSource=useSelector((state)=>state.Shipment.transportation[modeType])
 
  const disableMotTypeAndId=["B4","B2"].includes(procedure) // becoz typeId is disabled so in that case will not copy mot description in typeId

  const OnMotChange=({value,...rest})=>{
         if(["5","7"].includes(value) && !isImportShipment){
            
            saveData({mot:value,nationality:" ",...rest})
            onUpdate({mot:value?.trim(),nationality:"",...rest})

        }
    
    else{
    saveData({mot:value,...rest})
    onUpdate({mot:value?.trim(),...rest})
    }
    
  }
  const {validationMsg,isTransNationalityVisible,TransNationalityErrorMessage,isMotTypeIdVisible,isMotVisible,isMotTypeVisible}=useMemo(()=>{
         
    const response={}
    
    if(isImportShipment){
        response.isTransNationalityVisible=(["2", "5","7"].includes(dataSource.mot) || ["H2","H6"].includes(procedure)  )
        response.isMotVisible=["I2"].includes(procedure)
        response.isMotTypeVisible=true
        response.isMotTypeIdVisible=true
        response.validationMsg=<ul><li>if MOT is 2 or 5 or 7 or Procedure is H2 or H6 then Nationality will be disabled.</li>
          <li>if Procedure is I2 then MOT will be disabled.</li>
            <li>MOT Type and MOT Type Identification will be disabled for all import procedures
          </li></ul>
      
    }
    else{

      if(disableMotTypeAndId){
        response.isMotTypeVisible=true
        response.isMotTypeIdVisible=true
       
      }
      const isTransNationalityDisabled=["5","7"].includes(dataSource.mot)
        response.isTransNationalityVisible=isTransNationalityDisabled
        response.TransNationalityErrorMessage=!isTransNationalityDisabled ? "Nationality is mandatory" : []
        response.validationMsg=<ul><li>if Procedure is B4 or B2 then MOT type and MOT Type Identification will be disabled.</li></ul>
    }
 
    return response
},[dataSource.mot,procedure,disableMotTypeAndId,isImportShipment])




  useUpdateEffect(()=>{
    if(isMotTypeVisible && isMotTypeIdVisible && dataSource.transportId){
       saveData({type:" ",typeId:" ",modeType,transportId:dataSource.transportId})
       onUpdate({type:"",typeId:"",modeType,transportId:dataSource.transportId})
 }
 },[isMotTypeIdVisible,isMotTypeVisible])

 
useUpdateEffect(()=>{
  if(isTransNationalityVisible && isImportShipment && dataSource.transportId){
    saveData({"nationality":" ",modeType,transportId:dataSource.transportId})
    onUpdate({"nationality":"",modeType,transportId:dataSource.transportId})
}
},[isTransNationalityVisible])
  

useUpdateEffect(()=>{

  if(isMotVisible && dataSource.transportId){

 saveData({mot:" ",modeType,transportId:dataSource.transportId})
 onUpdate({mot:"",modeType,transportId:dataSource.transportId})
}
},[isMotVisible])

 return renderForm && renderForm(
     {
        title,
        modeType,
        disableFields:{mot:isMotVisible,type:isMotTypeVisible,typeId:isMotTypeIdVisible,nationality:isTransNationalityVisible},
        errorInfo:{nationality:!isTransNationalityVisible && !dataSource.nationality && TransNationalityErrorMessage},
        validationMsg,
        dataSource,
        saveData,
        onUpdate,
        onMotChange:OnMotChange
     }
 )

}

export default React.memo(BorderTransportMode)
